<div class="top-block">
	<div class="left-main-info">

		<form #editCustomerInfoForm="ngForm" autocomplete="off">
			<div class="customer-info form-main-info">
				<div class="form-block">
					<div class="form-label">
						Customer
					</div>
					<div class="form-uinfo">
						<p-dropdown (onChange)="qbChanged($event.value)" [options]="qbCustomers"
							[(ngModel)]="selectedQbCustomer" placeholder="Choose Customer" optionLabel="displayName"
							[ngModelOptions]="{standalone: true}" [disabled]="true">
						</p-dropdown>
					</div>
				</div>
				<div class="form-block">
					<div class="form-label">
						Customer Email
					</div>
					<div class="form-uinfo">
						<input pInputText BlockLateralArrowNavigation class="email-input" placeholder="" type="text" autocomplete="new-password"
							[(ngModel)]="customerEmail" name="email">
					</div>
				</div>
			</div>
			<div class="bills-info form-main-info">
				<div class="form-block">
					<div class="form-label">
						Billing address
					</div>
					<div class="form-uinfo">
						<textarea class="address-area bill-addrs" type="text" [(ngModel)]="billAddr"
							autocomplete="new-password" name="address"></textarea>
					</div>
				</div>

				<div class="form-column">
					<div class="form-row">
						<div class="form-block">
							<div class="form-label">
								Invoice Date
							</div>
							<div class="form-uinfo">
								<p-calendar [(ngModel)]="invDate" view="date" [tabindex]="-1" type="date"
									readonly="readonly" name="invDate" placeholder="" [showIcon]="true"
									[ngModelOptions]="{standalone: true}" [readonlyInput]="false" [showOnFocus]="false"
									[disabled]="true" [touchUI]="true" (onShow)="blurActiveElement()">
								</p-calendar>
							</div>
						</div>
						<div class="form-block">
							<div class="form-label">
								Due Date
							</div>
							<div class="form-uinfo">
								<p-calendar [(ngModel)]="dueDate" view="date" [tabindex]="-1" type="date"
									readonly="readonly" name="invDate" placeholder="Due Date" [showIcon]="true"
									class="editable-date-calendar" [ngModelOptions]="{standalone: true}"
									[readonlyInput]="false" [showOnFocus]="false" [touchUI]="true" (onShow)="blurActiveElement()">
								</p-calendar>
							</div>
						</div>
					</div>
					<div class="form-row">
						<div class="form-block" *ngFor="let customField of sale.customField">
							<div class="form-label">
								{{customField.name}}
							</div>
							<div class="form-uinfo">
								<input pInputText BlockLateralArrowNavigation class="custom-field-input" placeholder="" type="text"
									autocomplete="new-password" [(ngModel)]="customField.stringValue"
									[name]="customField.name">
							</div>
						</div>
					</div>

				</div>
			</div>
			<div class="bills-info form-main-info shipp-block">
				<div class="form-block">
					<div class="form-label">
						Shipping address
					</div>
					<div class="form-uinfo">
						<textarea class="address-area ship-addrs" type="text" [(ngModel)]="shipAddr"
							autocomplete="new-password" name="saddress"></textarea>
					</div>
				</div>
			</div>
			<!-- <div class="tags-block form-main-info">

			</div> -->
		</form>
	</div>
	<div class="right-main-info">
		<div class="total-label">
			<span *ngIf="sale.type === 'Estimate'">AMOUNT</span>
			<span *ngIf="sale.type !== 'Estimate'">BALANCE DUE</span>
		</div>
		<div class="total-uinfo">
			<span *ngIf="sale.type === 'Estimate'">{{sale.totalAmt | currency}}</span>
			<span *ngIf="sale.type !== 'Estimate'">{{sale.balance | currency}}</span>
		</div>
		<div class="create-invoice-block" *ngIf="sale.type === 'Estimate'">
			<button class="invoice-button" mat-button (click)="createInvoice()">Create Invoice</button>
		</div>
		<div class="total-payments" *ngIf="paymentsList?.length > 0">
			<div class="total-payment" *ngFor="let pmnt of paymentsList">
				${{pmnt?.totalAmt}}, {{pmnt?.metaData?.createTime | date: 'MMM d y'}}, #{{pmnt?.id}}
			</div>
		</div>
	</div>
</div>
<div class="middle-items-block">
	<app-sale-lines [items]="sale.line" [qbServClasses]="qbServClasses" [baseQbServClasses]="baseQbServClasses"
		(updateAfterSave)="showAfterSave()" *ngIf="!isMobile">
	</app-sale-lines>
</div>
<div class="mobile-items-block">
	<app-mobile-sale-line [items]="sale.line" [qbServClasses]="qbServClasses" [baseQbServClasses]="baseQbServClasses"
		*ngIf="isMobile"></app-mobile-sale-line>
</div>


<div class="subtotal-block">
	<div class="qb-files" *ngIf="!filesLoading">
		<ng-container *ngIf="qbFiles?.length > 0">
			<div class="file-label">
				Attachments:
			</div>

			<div class="qb-file" *ngFor="let qbFile of qbFiles" (click)="openFile(qbFile)">
				{{qbFile.fileName}}
			</div>
		</ng-container>
	</div>


	<div class="qb-files files-loading-block" *ngIf="filesLoading">
		<lib-mini-progress-spinner></lib-mini-progress-spinner>
	</div>

	<div style="flex: 1">

	</div>
	<div class="subtotal-info">
		<div class="info-line">
			<span *ngIf="showAddInfoAfterSave">Numbers below will be updated after save</span>
		</div>
		<div class="subtotal-line">
			<div class="subtotal-label">
				Subtotal:
			</div>
			<div class="subtotal-num">
				{{sale.totalAmt - sale.txnTaxDetail?.totalTax | currency}}
			</div>
		</div>
		<div class="subtotal-line">
			<div class="subtotal-label">
				Taxable Subtotal:
			</div>
			<div class="subtotal-num">
				{{sale.txnTaxDetail?.totalTax | currency}}
			</div>
		</div>
		<div class="subtotal-line">
			<div class="subtotal-label">
				Total:
			</div>
			<div class="subtotal-num">
				{{sale.totalAmt | currency}}
			</div>
		</div>
		<div class="subtotal-line">
			<div class="subtotal-label">
				Recieved Payments:
			</div>
			<div class="subtotal-num">
				{{sale.recievedPayments | currency}}
				<!-- {{(sale.totalAmt - sale.balanceDue) | currency}} -->
			</div>
		</div>
		<div class="subtotal-line">
			<div class="subtotal-label">
				Balance Due:
			</div>
			<div class="subtotal-num">
				{{sale.balance | currency}}
			</div>
		</div>
	</div>
</div>
<div class="bottom-block">
	<div class="bottom-buttons">
		<button mat-button class="save-info-button delete-button" (click)="deleteEstInv()"
			[disabled]="deleteLoadingSpinner" [ngClass]="{'disabled-button': deleteLoadingSpinner}">
			<span *ngIf="!deleteLoadingSpinner">Delete</span>
			<lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
		</button>

		<p-confirmDialog appendTo="body" icon="pi pi-trash" styleClass="estimate-invoice-confirm-panel">
		</p-confirmDialog>

		<div style="flex: 1">

		</div>

		<!-- <button mat-button class="save-info-button" (click)="saveInfo()" disabled>Save</button> -->
		<button mat-button class="save-info-button" (click)="saveInfoButton()" [disabled]="loadingSpinner"
			[ngClass]="{'disabled-button': loadingSpinner}">
			<span *ngIf="!loadingSpinner">Save</span>
			<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
		</button>

		<button mat-button class="save-info-button" (click)="sendInQb()">
			<span>Send in QB</span>
		</button>

		<button mat-button class="save-info-button save-n-send" (click)="sendEmail()" [disabled]="saveNSendLoading"
			[ngClass]="{'disabled-button': saveNSendLoading}">
			<span *ngIf="!saveNSendLoading">Save And Send</span>
			<lib-mini-progress-spinner *ngIf="saveNSendLoading"></lib-mini-progress-spinner>
		</button>

	</div>
</div>
